// extracted by mini-css-extract-plugin
module.exports = {"content":"Leventis_content__3odiO"};